import { render, staticRenderFns } from "./ActuarialPlanMargins.vue?vue&type=template&id=fbdc5e6a&scoped=true&"
import script from "./ActuarialPlanMargins.vue?vue&type=script&lang=js&"
export * from "./ActuarialPlanMargins.vue?vue&type=script&lang=js&"
import style0 from "./ActuarialPlanMargins.vue?vue&type=style&index=0&id=fbdc5e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdc5e6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
